module.exports = __webpack_public_path__ + "img/Recurso-5.673f7b63.png";